export const QuoteStatusEnum = {
  PendingNew: 'PendingNew',
  Open: 'Open',
  PendingCancel: 'PendingCancel',
  Canceled: 'Canceled',
  PendingFill: 'PendingFill',
  Filled: 'Filled',
  Closed: 'Closed',
  Rejected: 'Rejected',
  Excluded: 'Excluded',
  Holding: 'Holding',
} as const;
export type QuoteStatusEnum = (typeof QuoteStatusEnum)[keyof typeof QuoteStatusEnum];

export const TradeStatusEnum = {
  Confirmed: 'Confirmed',
  Pending: 'Pending',
  Canceled: 'Canceled',
} as const;
export type TradeStatusEnum = (typeof TradeStatusEnum)[keyof typeof TradeStatusEnum];

export const ExposureStatusEnum = {
  Online: 'Online',
  Offline: 'Offline',
} as const;
export type ExposureStatusEnum = (typeof ExposureStatusEnum)[keyof typeof ExposureStatusEnum];
